import { render, staticRenderFns } from "./DispensedItems.vue?vue&type=template&id=c627e2d0&"
import script from "./DispensedItems.vue?vue&type=script&lang=ts&"
export * from "./DispensedItems.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports